import useTranslation from 'hooks/useTranslation'
import Popup from 'components/popups/Popup'
import { countBadge } from '../MagElement'
import { useReduxSelector } from 'store'
import { selectConfig } from 'appSlice'
import { Fragment } from 'react'
import '../style.scss'

interface DetailsData {
  name?: string
  key: string
  list: DetailsList[]
}

interface DetailsList {
  id: string
  key: string
  name: string
  icon?: string
  description?: string
  isImportant: boolean
  price?: string
  title?: string
}
interface DetailsPopupProps {
  rentableType?: warehouse.RentableType
  data: DetailsData[]
  count?: number
}

const DetailsPopup: React.FC<DetailsPopupProps> = ({ data, count = 0, rentableType }) => {
  const config = useReduxSelector(selectConfig)
  const { t } = useTranslation('mapDetails')

  const getCountLabel = (count: number) => {
    if (rentableType === 'parking') {
      switch (true) {
        case count > 4: return `${t('thereAre>=5SuchParkingAvailable-array')[0]} ${count} ${t('thereAre>=5SuchParkingAvailable-array')[1]}`
        case count > 1: return `${t('thereAreOnly<5SuchParkingAvailable-array')[0]} ${count} ${t('thereAreOnly<5SuchParkingAvailable-array')[1]}`
        case count === 1: return t('lastParkingOfThisTypeAvailable')
        default: return t('thereAreNoParkingLikeThisAnymore')
      }
    }

    switch (true) {
      case count > 4: return `${t('thereAre>=5SuchWarehousesAvailable-array')[0]} ${count} ${t('thereAre>=5SuchWarehousesAvailable-array')[1]}`
      case count > 1: return `${t('thereAreOnly<5SuchWarehousesAvailable-array')[0]} ${count} ${t('thereAreOnly<5SuchWarehousesAvailable-array')[1]}`
      case count === 1: return t('lastWarehouseOfThisTypeAvailable')
      default: return t('thereAreNoWarehousesLikeThisAnymore')
    }
  }

  return (
    <Popup>
      <div className='popup__title'>
        <div>{t('details')}</div>
      </div>
      <div className='popup__magDetails'>
        {config?.showAvailableQuantity && <div className='popup__magDetails__item'>
          <div className='popup__magDetails__item__top'>
            <div className='amount__bg'>
              <span className={`${countBadge(count)}`} />
            </div>
            <div className='popup__magDetails__title'>{getCountLabel(count)}</div>
          </div>
        </div>}
        {data?.map(({ key, name, list }) => list?.length > 0
          ? <Fragment key={key}>
            {name && <div className='popup__magDetails__title'>{name}</div>}
            {list.map(({ key, title, name, price, description }) => <div
              key={key}
              className='popup__magDetails__item'>
              {price
                ? <div className='popup__magDetails__item__top --group'>
                  <div className='popup__magDetails__title'>{name}</div>
                  <div className='popup__magDetails__price'>{price}</div>
                </div>
                : <div className='popup__magDetails__item__top'>
                  <i className={`icon icon--${key}-bold`} />
                  <div className='popup__magDetails__title'>{title}</div>
                </div>}
              <div className='popup__magDetails__desc'>{price ? description : name}</div>
            </div>)}
          </Fragment>
          : null)}
      </div>
    </Popup>
  )
}

export default DetailsPopup